import { Component, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { TimepickerDialogComponent } from "../timepicker-dialog/timepicker-dialog.component";
import { MatFormField, MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { InputErrorComponent } from "../error/error.component";
import { TranslatePipe } from "@ngx-translate/core";
@Component({
  selector: "app-custom-timepicker",
  templateUrl: "./custom-timepicker.component.html",
  styleUrls: ["./custom-timepicker.component.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIconButton,
    MatSuffix,
    MatIcon,
    InputErrorComponent,
    TranslatePipe,
  ],
})
export class CustomTimepickerComponent {
  dialog = inject(MatDialog);
  private rootFormGroup = inject(FormGroupDirective);

  @Input("givenFormGroup") form!: FormGroup;
  @Input("givenFormControlName") givenFormControlName!: string;

  openTimePicker(): void {
    const dialogRef = this.dialog.open(TimepickerDialogComponent, {
      width: "300px",
      height: "500px",
    });
    const instance = dialogRef.componentInstance;
    instance.givenFormGroup = this.form;
    instance.givenFormControlName = this.givenFormControlName;
  }
}
